/**
 * The default margin in pixels to check above or below the viewport for an element to be
 * considered "near" the viewport and eligible for lazy loading.
 */
export const DEFAULT_NODE_NEAR_VIEWPORT_MARGIN = 200;

/**
 * Number of times to retry refreshing an ad if GAM returns an empty response.
 * If no creative is delivered after this many retries, then refresh will
 * be turned off for the ad slot.
 */
export const DEFAULT_EMPTY_RETRY_COUNT = 1;
